import { ProductTargetingExpressionNodeQueryFe } from "@intelligems/ig-types/fe-only/experience-product-targeting";
import { createAsyncThunk } from "@src/store/createAsyncThunk";
import {
  openProductPicker,
  setProductPickerSelectedProducts,
} from "@src/store/slices/productPicker";
import {
  ProductPickerExperienceProductTargeting,
  ProductPickerSelectedProduct,
} from "@src/store/slices/productPicker/types";

export const openExpProductTargetingProductPicker = createAsyncThunk<
  void,
  Omit<ProductPickerExperienceProductTargeting, "type"> & {
    selectedProductIds: string;
    expressionQuery: ProductTargetingExpressionNodeQueryFe;
  }
>(
  "productPicker/openExpProductTargetingProductPicker",
  async (
    {
      selectedProductIds,
      expressionsListIndex,
      expressionsIndex,
      expressionQuery,
    },
    { dispatch }
  ) => {
    dispatch(
      openProductPicker({
        type: "experienceProductTargeting",
        expressionsListIndex,
        expressionsIndex,
      })
    );

    if (selectedProductIds === "") {
      dispatch(setProductPickerSelectedProducts([]));
    } else {
      const formattedProductIds: string[] = selectedProductIds.split(",");

      const baseProductsFormatted: ProductPickerSelectedProduct[] =
        formattedProductIds.map((p) => {
          const foundProductDisplay = expressionQuery?.displayData?.[p];
          return {
            id: p,
            title: foundProductDisplay?.title || "",
            image: foundProductDisplay?.image || undefined,
            handle: "",
            requiresSellingPlan: false,
          };
        });
      dispatch(setProductPickerSelectedProducts(baseProductsFormatted));
    }
  }
);
